import React from 'react';
import {Box, Typography} from '@mui/material';

/**
 * Panel-standard page title row (matches customers / members / forms lists).
 */
const PageHeader = ({title, actions = null}) => (
    <Box
        sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 0,
            mb: 3,
        }}
    >
        <Typography variant="h6" fontWeight={600}>
            {title}
        </Typography>
        {actions}
    </Box>
);

export default PageHeader;
